import React from "react";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useMoralis } from "react-moralis";
import InfoList from "./InfoList";

const ForGreenUsers = () => {
  const { isAuthenticated } =
    useMoralis();

  return (
    <Card
      sx={{
        maxWidth: "400px",
      }}
    >
      <CardContent>
        <Typography variant="h5">For Climate Change Heroes</Typography>
        <List>
          <ListItem>
            <ListItemText
              primary="Fight climate change with a single transaction."
              secondary={<InfoList items={[
                "Choose the amount of DAI you would like to submit and the number of days you would like it to distributed out over.",
                "Your funds will act as rewards for new and existing solar panel owners for producing green energy.",
                "Help the fight against climate change by incentivising growth in the entire solar industry."
              ]} offset={1} />}
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="Earn tokens!"
              secondary={<InfoList items={[
                "Earn SLL tokens based on the amount of energy generated by registered solar plants. The more they generate the more you earn!"
              ]} emoji="⭐" />}
            />
          </ListItem>
        </List>
      </CardContent>
      <CardActions
        sx={{
          display: "flex",
          justifyContent: "center",
          mb: 2,
        }}
      >
        <Button
          variant="contained"
          disableElevation
          component={Link}
          disabled={!isAuthenticated}
          to="/submit-funds"
        >
          Submit DAI
        </Button>
      </CardActions>
    </Card>
  );
};

export default ForGreenUsers;
